import { AxiosResponse } from 'axios'
import { $axios } from './axios'
import { CreateCustomizedSourceContentType, CustomizedSourceContentType } from '../../server/models/CustomizedSourceContent'

export const createCustomizedSourceContentWithBrandDetails = (
  body: CreateCustomizedSourceContentType
): Promise<AxiosResponse<CustomizedSourceContentType>> => {
  return $axios.post(`/customized-content`, body)
}
